import Vue from 'vue';
import MultiSelect from 'primevue/multiselect';

Vue.component('MultiSelect', MultiSelect);
